<script lang="ts">
  import HeroBlurb from './HeroBlurb.svelte';
  import type {
    GlobalProperties,
    UseFormattedProps,
  } from 'customer-components/lib/types';

  export let properties: UseFormattedProps;
  export let settings: GlobalProperties;

  $: ({ backgroundHeroImage } = properties);
</script>

<section
  class="pg-wrap"
  style="background:var(--vlt-lp-background);"
  id={properties?.anchor}
>
  <div class="main-section wf-section">
    <div class="main-container">
      <div class="blurb">
        <figure
          class="hero-image"
          style="background-image:url('{backgroundHeroImage}');"
        />
        <HeroBlurb {properties} {settings} wide short centered />
      </div>
    </div>
  </div>
</section>

<style lang="scss">
  .blurb {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--spacing-atom);
    width: 100%;
  }

  .main-section {
    display: flex;
    padding: 25px 27px;
    flex-direction: column;
    align-items: center;
    background-color: var(--background-color);
    color: var(--text-color, #0e0f11);
    font-family: var(--text-font, 'DM Sans');
  }

  .main-container {
    display: flex;
    width: 100%;
    max-width: 1300px;
    flex-direction: column;
    align-items: flex-start;
  }

  .hero-image {
    position: relative;
    display: flex;
    flex-shrink: 0;
    width: 600px;
    height: 300px;
    padding: 10px;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .hero-image::before {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 33%;
    background-image: linear-gradient(transparent, var(--vlt-lp-background));
  }

  @media screen and (max-width: 767px) {
    .main-section {
      padding: 25px 15px;
    }

    .blurb {
      flex-direction: column;
    }

    .hero-image {
      width: calc(100% - var(--spacing-large));
      height: unset;
      aspect-ratio: 16 / 9;
    }
  }
</style>
